/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SmartProblemDetails,
  SystemPromptItemDto,
} from '../models/index';
import {
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
    SystemPromptItemDtoFromJSON,
    SystemPromptItemDtoToJSON,
} from '../models/index';

export interface SystemPromptPutRequest {
    systemPromptItemDto?: SystemPromptItemDto;
}

/**
 * 
 */
export class SystemPromptApi extends runtime.BaseAPI {

    /**
     */
    async deleteSystemPromptRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/SystemPrompt`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async deleteSystemPrompt(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.deleteSystemPromptRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async systemPromptGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SystemPromptItemDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/SystemPrompt`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemPromptItemDtoFromJSON(jsonValue));
    }

    /**
     */
    async systemPromptGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SystemPromptItemDto> {
        const response = await this.systemPromptGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async systemPromptPutRaw(requestParameters: SystemPromptPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SystemPromptItemDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/SystemPrompt`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SystemPromptItemDtoToJSON(requestParameters['systemPromptItemDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemPromptItemDtoFromJSON(jsonValue));
    }

    /**
     */
    async systemPromptPut(requestParameters: SystemPromptPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SystemPromptItemDto> {
        const response = await this.systemPromptPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
